import AppCardTotalLayout from './AppCardTotalLayout.vue';

export default AppCardTotalLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/cardlayouts/CardTotalLayout/index.ts